import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings, getEventForWeekly, needsApproval } from '../util/Utility.js';
import moment from 'moment';
import { Checkbox } from 'react-bootstrap';
import {CCOButtonGroup} from '../util/Components';

export default class EventsWeekView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      type: 0
    }
  }

  fetchObjects(limit, callback) {
    clearBindings();
    if (this.state.type === 0 || this.state.type === 2) {
      listenTo("events", this, callback, {
        orderByChild: 'date',
        startAt: moment().startOf('day').unix(),
        limitToLast: limit
      }, e => {
        if (this.state.type === 2) {
          return needsApproval(e) !== null && !e.show;
        } else {
          return !e.canceled && e.show;
        }
      })
    } else {
      listenTo("weekly", this, data => {
        console.warn(data);
        let eventArray = [];
        Object.keys(data).forEach(key => {
          eventArray.push(getEventForWeekly({...data[key], key}));
        });
        callback(eventArray)
      }, {
        limitToLast: limit
      }, e => !e.archived, false)
    }
  }

  componentWillUnmount() {
    clearBindings();
  }

  typeChanged(newType) {
    this.setState({type: newType});
  }

  render() {
    let approvalPermissions = this.props.permissions.approval1 || this.props.permissions.approval2 || this.props.permissions.approval3 || this.props.permissions.approval4;

    var sections = [];
    sections.push({title: moment().add(0, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(0, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(0, 'days').startOf('day')) });
    sections.push({title: moment().add(1, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(1, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(1, 'days').startOf('day')) });
    sections.push({title: moment().add(2, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(2, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(2, 'days').startOf('day')) });
    sections.push({title: moment().add(3, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(3, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(3, 'days').startOf('day')) });
    sections.push({title: moment().add(4, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(4, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(4, 'days').startOf('day')) });
    sections.push({title: moment().add(5, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(5, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(5, 'days').startOf('day')) });
    sections.push({title: moment().add(6, 'days').format("dddd, MMMM Do"), filter: e => moment.unix(e.date).isBefore(moment().add(6, 'days').endOf('day')) && moment.unix(e.date).isAfter(moment().add(6, 'days').startOf('day')) });

    return ( <center>
      <CCOButtonGroup onClick={this.typeChanged.bind(this)} items={approvalPermissions ? ["Special Events", "Recurring Events", "Pending Events"] : ["Special Events", "Recurring Events"]} width={500} />
      <div style={{marginTop: 8}}><center><Checkbox checked={this.state.setup} onChange={() => this.setState({setup: !this.state.setup})}>Show event setup details</Checkbox></center></div>
      <PanelHolder sections={this.state.type === 1 ? sections : null} fetch={this.state.type} type="eventsWeek" setup={this.state.setup} eventType={this.state.type} fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center> );
  }
}



/** WEBPACK FOOTER **
 ** ./src/overview/EventsWeekView.js
 **/